<template>
  <div
    class="c-outages-footer"
    :class="{ 'c-outages-footer--list-view': outagePageView === 'list' }"
  >
    <div
      class="c-outages-footer__report"
      :class="{
        'c-outages-footer__report--list-view': outagePageView === 'list',
      }"
    >
      <div class="c-outages-footer__report-inner">
        <img src="_resources/app/client/assets/icons/outages-map/alert-icon.svg" />
        <h2 class="c-outages-footer__report-title">
          No power and can't see your outage?
        </h2>
        <a
          v-if="cmsContent.reportOutageLink"
          :href="cmsContent.reportOutageLink"
          class="c-outages-footer__report-link"
        >
          <button class="c-outages-footer__report-button">{{ cmsContent.reportOutageText }}</button>
        </a>
      </div>
    </div>
    <div
      class="c-outages-footer__panels"
      :class="{
        'c-outages-footer__panels--list-view': outagePageView === 'list',
      }"
    >
      <div
        v-for="featuredImage in cmsContent.featuredImages"
        :key="featuredImage.SortOrder"
        class="c-outages-footer__panel"
        :class="{
          'c-outages-footer__panel--list-view': outagePageView === 'list',
        }"
      >
        <div class="c-outages-footer__panel-image-wrapper">
          <img
            :src="featuredImage.Image"
            class="c-outages-footer__panel-image"
          />
        </div>
        <a
          :href="featuredImage.Link"
          class="c-outages-footer__panel-link"
          :alt="featuredImage.Description"
          >{{ featuredImage.LinkTitle }}</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
  created() {},
  components: {},
  mounted() {},
  computed: {
    ...mapFields(["outagePageView", "cmsContent"]),
  },
  methods: {},
};
</script>

<style lang="scss"></style>
